import React, { useState, useEffect } from 'react'
import axios from 'axios'
import LanguageJsonUploadView from '../../Components/Language/LanguageJsonUploadView'

const LanguageUploadPage = () => {
  const [langJson, setLangJson] = useState([])

  const getLangJson = () => {
    axios
      .get(`/new/webAdmin/v2/lang/json`, {
        headers: {
          token: sessionStorage.getItem('token'),
        },
      })
      .then(({ data }) => {
        setLangJson(data.result || [])
      })
  }

  const updateLangJson = async (seq, json) => {
    try {
      const { data } = await axios.put(
        `/new/webAdmin/v2/lang/json/${seq}`,
        {
          languageJson: JSON.stringify(json),
        },
        {
          headers: {
            token: sessionStorage.getItem('token'),
          },
        }
      )

      return data.status === 'success'
    } catch (err) {
      return false
    }
  }

  useEffect(() => {
    getLangJson()
  }, [])

  return (
    <LanguageJsonUploadView
      langJson={langJson}
      getLangJson={getLangJson}
      updateLangJson={updateLangJson}
    />
  )
}

export default LanguageUploadPage
